import {notebook13, bookmark1, bookmark2} from "../assets"
const sliderProducts = [
    {
      id: 1,
      image: notebook13,
      name: "Today I am Grateful Notebook",
      price: "Rs. 499"
    },
    {
      id: 2,
      image: bookmark1,
      name: "Dream Bookmark",
      price: "Rs. 299"
    },
    {
      id: 3,
      image: bookmark2,
      name: "Your Word Bookmark",
      price: "Rs. 299"
    }
  ];
  
  export default sliderProducts;